import React from "react";

import { addDoc, collection, getFirestore } from "firebase/firestore";

import app from "../firebase";

import { getStorage } from "firebase/storage";
import { AuthCodeType } from "../../types/common";
import useModal from "../context/modalContext";
import { Dev } from "../util/consoleUtil";

const db = getFirestore(app);
const storage = getStorage(app);

export const CodeService = {
  Create: () => {
    const { pushAlert } = useModal();
    const [isLoading, setIsLoading] = React.useState(false);

    const runRequest = async (payload: AuthCodeType) => {
      try {
        setIsLoading(true);

        const mainRef = collection(db, "authCodes");
        const mainSnap = await addDoc(mainRef, payload);

        setIsLoading(false);
        return true;
      } catch (error) {
        console.log(...new Dev("Request Error [create]", error).Error());

        pushAlert({
          type: "error",
          message: "Erro ao abter dados. Verifique sua conexão.",
        });
        setIsLoading(false);
        return false;
      }
    };

    return { isLoading, runRequest };
  },
};
